import {combineReducers} from '@reduxjs/toolkit';
import assetsLibraryReducer from './assetsLibrary/assetsLibrary.slice';

const assetsLibraryPageReducer = combineReducers({
  assetsLibrary: assetsLibraryReducer,
});

export default assetsLibraryPageReducer;

